import React from 'react';
import { useLocation } from 'react-router-dom';
import { LegalNav } from './PrivacyPolicy';
import './LegalPage.css';

const TermsConditions = () => {
  useLocation(); // needed to keep LegalNav reactive
  return (
    <div className="legal-page">
      <h1>Términos y condiciones</h1>
      <p className="legal-updated">Última actualización: octubre de 2026</p>
      <LegalNav />

      <h2>1. Objeto y aceptación</h2>
      <p>
        Los presentes términos regulan el acceso y uso de la plataforma <strong>Almaley</strong> (almaley.com), un servicio de preparación de oposiciones basado en inteligencia artificial. Al registrarte o utilizar el servicio, aceptas estos términos en su totalidad.
      </p>

      <h2>2. Acceso al servicio</h2>
      <p>
        Almaley es un servicio de acceso restringido mediante cuenta de usuario. Debes tener al menos 16 años para registrarte. Eres responsable de mantener la confidencialidad de tus credenciales y de todo el uso que se haga de tu cuenta.
      </p>

      <h2>3. Uso permitido</h2>
      <p>Puedes utilizar Almaley exclusivamente para tu preparación personal de oposiciones. Queda prohibido:</p>
      <ul>
        <li>Reproducir, distribuir o comercializar los contenidos de la plataforma sin autorización expresa.</li>
        <li>Utilizar herramientas automáticas (bots, scrapers) para extraer datos.</li>
        <li>Intentar acceder a datos de otros usuarios o a zonas restringidas del sistema.</li>
        <li>Realizar cualquier uso que contravenga la legislación vigente.</li>
      </ul>

      <h2>4. Contenidos generados por IA</h2>
      <p>
        Parte del contenido de Almaley (resúmenes, preguntas, correcciones) es generado por modelos de inteligencia artificial. Aunque trabajamos para garantizar su exactitud, <strong>no garantizamos que el contenido esté libre de errores</strong>. No debe utilizarse como única fuente de estudio ni como asesoramiento jurídico.
      </p>

      <h2>5. Propiedad intelectual</h2>
      <p>
        Los textos legales del temario provienen de fuentes oficiales (BOE) y son de dominio público. El software, diseño, marca y contenido propio de Almaley son propiedad de sus titulares y están protegidos por la legislación de propiedad intelectual.
      </p>

      <h2>6. Disponibilidad del servicio</h2>
      <p>
        Almaley se ofrece «tal como está». No garantizamos una disponibilidad ininterrumpida del servicio. Podemos suspender o modificar el servicio en cualquier momento, con aviso previo siempre que sea posible.
      </p>

      <h2>7. Limitación de responsabilidad</h2>
      <p>
        En la máxima medida permitida por la ley, Almaley no será responsable de los daños indirectos, incidentales o consecuentes derivados del uso o la imposibilidad de uso del servicio.
      </p>

      <h2>8. Modificación de los términos</h2>
      <p>
        Podemos actualizar estos términos. La continuación del uso del servicio tras la publicación de cambios implica la aceptación de los nuevos términos.
      </p>

      <h2>9. Ley aplicable y jurisdicción</h2>
      <p>
        Estos términos se rigen por la legislación española. Para cualquier controversia, ambas partes se someten a los juzgados y tribunales de España, salvo que la normativa aplicable establezca un fuero imperativo diferente.
      </p>

      <h2>10. Contacto</h2>
      <p>
        Para cualquier consulta sobre estos términos: <a href="mailto:legal@almaley.com">legal@almaley.com</a>. Los datos identificativos del titular figuran en el <a href="/legal/aviso-legal">Aviso legal</a>.
      </p>
    </div>
  );
};

export default TermsConditions;
